export const getPresignedUrls = (state) =>
  state.libraryCards?.presignedUrls || null;
export const getLibraryCardIndexTags = (state) => {
  return state.libraryCards?.libraryCardTags || null;
};
export const getLibraryCards = (state) =>
  state.libraryCards?.cardDetails || null;
export const getListCards = (state) => {
  return state.libraryCards?.listCards || null;
};
// Getter for entity-specific card lists
export const getEntityCards = (state, entityType) => {
  const result = state.libraryCards?.entityCards?.[entityType] || [];
  console.log(
    `getEntityCards - entityType: ${entityType}, result:`,
    result,
    `all entityCards keys:`,
    Object.keys(state.libraryCards?.entityCards || {})
  );
  return result;
};
// Legacy getter for agent config list (for compatibility)
export const getAgentConfigList = (state) => {
  return getEntityCards(state, "AGENTCONFIG");
};
export const getAgentConfigLoading = (state) => {
  return state.libraryCards?.loading || false;
};
